module.exports = __webpack_public_path__ + "static/media/oil_thumb.6027fd46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/oil_thumb.png
// module id = 447
// module chunks = 0